import StoredLayout from '../../layouts/StoredLayout'
import CodeStructure from './CodeStructure'
export default StoredLayout(CodeStructure)



// WEBPACK FOOTER //
// ./src/documentation/code-structure/index.js